import { Injectable } from '@angular/core';

import { DataTransferEffect, DndState } from './models';
import { setDragData } from './utils';

@Injectable()
export class StateService {
  dragState: DndState = {
    data: null,
    isDragging: false,
    dropEffect: DataTransferEffect.None,
    startIndex: null
  };

  startDrag(event: DragEvent, data: any, startIndex: number) {
    this.dragState.isDragging = true;
    this.dragState.dropEffect = DataTransferEffect.None;
    this.dragState.data = data;
    this.dragState.startIndex = startIndex;
    event.dataTransfer.effectAllowed = DataTransferEffect.Move;
    setDragData(event, {data});
  }

  endDrag() {
    this.dragState.isDragging = false;
    this.dragState.data = null;
    this.dragState.dropEffect = null;
    this.dragState.startIndex = null;
  }

  setDropEffect(event: DragEvent, dropEffect: DataTransferEffect) {
    if (this.dragState.isDragging) {
      this.dragState.dropEffect = dropEffect;
    }

    event.dataTransfer.dropEffect = dropEffect;
  }
}
